<template>
    <general-table
        :columns="columnsComputed"
        :filters="filters"
        :url="route('messages.table.details', messageDeliverableId)"
        order-by="id"
        order-dir="desc"
    >
    </general-table>


</template>

<script>
import MessageTableGroup from "./MessageTableGroup";
import MessageTableMessage from "./MessageTableMessage";
import MessageTableStatus from "./MessageTableStatus";
import MessageTableSendTime from "./MessageTableSendTime";
import MessageTableLinkVisits from "./MessageTableLinkVisits";
import MessageSentTableRecipientName from "./MessageSentTableRecipientName.vue";
import GeneralTable from "./GeneralTable/GeneralTable.vue";
import {markRaw} from 'vue';
export default {
    components: { MessageTableGroup, GeneralTable},
    props: {
        messageDeliverableId: {
            type: String,
            default: null
        },
        hasLinks: {
          type: Boolean,
          default: false
        }
    },
    data() {
        return {
            filters: [
                {
                    label: "Contact",
                    value: "contact",
                    type: "contact",
                    multiple: false, // because contact component already supports multiple
                },
                {
                    label: "Send Date Since",
                    value: "send_date_start",
                    type: "date",
                    multiple: false,
                },
                {
                    label: "Send Date Until",
                    value: "send_date_end",
                    type: "date",
                    multiple: false,
                },
                {
                    label: "Status",
                    value: "status",
                    type: "select",
                    multiple: true,
                    options: [
                        { label: "Delivered", value: "delivered" },
                        { label: "Sent", value: "sent" },
                        { label: "Pending", value: "pending"},
                        { label: "Queued", value: "queued" },
                        { label: "Failed", value: "failed" },
                    ],
                },
            ],
        };
    },
  computed: {
    columnsComputed: function() {
      let cols = [
        {
          label: "STATUS",
          name: "status",
          sortable: true ,
          component: markRaw(MessageTableStatus),
          width: '95px',
        },
        {
          label: "SEND DATE/TIME",
          name: "true_send_time",
          sortable: true,
          component: markRaw(MessageTableSendTime),
          width: '200px'
        },
        {
          label: "RECIPIENT",
          name: "recipient_name",
          sortable: true,
          component: markRaw(MessageSentTableRecipientName),
          width: '200px',
        },
        {
          label: "MESSAGE",
          name: "parsed_message",
          sortable: false,
          width: '1fr',
          component: markRaw(MessageTableMessage),
        },
      ];

      if (this.hasLinks) {
        cols.push({
          label: "LINK CLICKS",
          name: "link_visits",
          sortable: false,
          component: markRaw(MessageTableLinkVisits),
          width: '100px'
        })
      }

      return cols;
    }
  },
};
</script>
